import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Info } from 'react-feather';
import {
  TabbedView,
  Tab,
  TabList,
  TabPanel,
} from 'components/shared/TabbedView';
import Tooltip from 'components/shared/Tooltip';
import Header from './Header';
import LessonMetadata from './LessonMetadata/index';
import LessonEngagement from './LessonEngagement';
import LessonPerformance from './LessonPerformance';
import LessonSettings from './LessonSettings';
import LessonPermissions from './LessonPermissions';
import ReadyToAssign from './ReadyToAssign';

const TooltipText = () => (
  <span className="w-260 p-8 d-f fd-c ws-pr fz-14 lh-16 ff-ss text-wrap">
    {t('lesson_overview.export_report_tooltip')}
  </span>
);

const LessonOverviewLayout = ({ lesson: lessonProp, urls, workspaces }) => {
  const [lesson, setLesson] = useState(lessonProp);
  const [tabIndex, setTabIndex] = useState(0);
  const isLessonDataTab = tabIndex === 0 || (!lesson.scorm && tabIndex === 1);

  return (
    <>
      <Header lesson={lesson} urls={urls} />
      <LessonMetadata
        lesson={lesson}
        setLesson={setLesson}
        workspaces={workspaces}
      />
      {isLessonDataTab && <ReadyToAssign lesson={lesson} />}
      <TabbedView onSelect={setTabIndex} selectedIndex={tabIndex}>
        <TabList className="mb-24 mt-16" tabClassName="c-brand-night">
          <Tab>{t('lesson_overview.engagement')}</Tab>
          {!lesson.scorm && <Tab>{t('lesson_overview.performance')}</Tab>}
          <Tab>{t('lesson_overview.settings')}</Tab>
          <Tab>{t('lesson_overview.permissions')}</Tab>
          {isLessonDataTab && (
            <div className="float-right mb-16 d-f ai-c">
              <a
                href={urls.exportReport}
                data-remote
                className="ws-nw ml-12 mr-8 mt-12 lh-24 fz-16 td-n c-brand-blue ff-ss h-td-u haf-c-lhci"
              >
                {t('lesson_overview.export_report')}
              </a>
              <Tooltip align="end" text={<TooltipText />}>
                <Info className="mt-16 c-midnight-50" size={18} />
              </Tooltip>
            </div>
          )}
        </TabList>
        <TabPanel>
          <LessonEngagement />
        </TabPanel>
        {!lesson.scorm && (
          <TabPanel>
            <LessonPerformance />
          </TabPanel>
        )}
        <TabPanel>
          <LessonSettings />
        </TabPanel>
        <TabPanel>
          <LessonPermissions />
        </TabPanel>
      </TabbedView>
    </>
  );
};

LessonOverviewLayout.propTypes = {
  lesson: PropTypes.shape({
    id: PropTypes.number,
    permissions: PropTypes.shape({
      canChangePublicitySettings: PropTypes.bool,
      canViewGradebook: PropTypes.bool,
    }),
    scorm: PropTypes.bool,
    title: PropTypes.string,
  }),
};

export default props => <LessonOverviewLayout {...props} />;
